import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Recipe APIs
export const recipeAPI = {
  search: (query) => api.get(`/recipes/search?query=${query}`),
  getSuggestions: () => api.get('/recipes/suggestions'),
  getAll: (params) => api.get('/recipes', { params }),
  getById: (id) => api.get(`/recipes/${id}`),
  create: (data) => api.post('/recipes', data),
  delete: (id) => api.delete(`/recipes/${id}`)
};

// User APIs
export const userAPI = {
  register: (data) => api.post('/users/register', data),
  login: (data) => api.post('/users/login', data),
  getProfile: () => api.get('/users/profile'),
  addFavorite: (recipeId) => api.post('/users/favorites', { recipeId }),
  removeFavorite: (recipeId) => api.delete(`/users/favorites/${recipeId}`)
};

export default api;